var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navbar-button-template',{on:{"click":_vm.toggleOpenMenu}},[(_vm.hasUnreadNotifications)?_c('div',{staticClass:"h-2 w-2 rounded-md absolute right-0 mr-1",staticStyle:{"background-color":"#EB8234"}}):_vm._e(),_c('fa-icon',{class:{'animate-ring': _vm.hasUnreadNotifications},attrs:{"icon":['far', 'bell'],"fixed-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }